import { globalSearchActions } from './constants.js';

const initialState = {
    closeSearch: false,
};

const GlobalSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case globalSearchActions.close:
            return { ...state, closeSearch: true };

        case globalSearchActions.reset:
            return { ...state, closeSearch: false };

        default:
            return state;
    }
};

export default GlobalSearchReducer;
